import * as core from '../core';

export const verifiableCredentialDataSchema = core.serialization.object({
    id: core.serialization.string(),
    digestMultibase: core.serialization.string().optional(),
});
